import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

import { SubCategoryListLayer } from "../components/SubCategoryListLayer";

export const SubCategoryListPage = () => {
  return (
    <MasterLayout>
      <SubCategoryListLayer />
    </MasterLayout>
  );
};
